import { styled } from '@mui/material';
import { Typography } from '../../atoms/Typography';

export const StyledTypography = styled(Typography)`
  white-space: unset;
  word-break: break-all;
`;